module.exports = __webpack_public_path__ + "img/VL_08_01.6033e7db.png";